import axios from "axios";
import QS from "qs";
import xlooLib from "../../../librarys/xlooLib";

export default {
    SET_getSiteCustomization: async (context) => {
        let urlDonorPortal;
        let subdomain = '/'
        if (location.hostname === 'localhost') {
            urlDonorPortal = 'http://localhost:8080/donorportal/';
        } else {
            const arrPathname = location.pathname.split('/')
            if (arrPathname[1] === 'donorportal') {
                subdomain = '/donorportal/'
            } else {
                subdomain = '/'
            }
            urlDonorPortal = location.origin + subdomain
        }
        if (typeof subdomain !== 'undefined') {
            context.commit('set_configurationSiteUrlSubdomain', subdomain);
        }

        if (typeof urlDonorPortal !== 'undefined') {
            context.commit('set_configurationSiteUrlSite', urlDonorPortal);
        }
        const dataRequest = {
            action: 'getSiteCustomization'
        }
        const urlRequestApi = urlDonorPortal + 'api'
        try {
            const res_firstStep = await axios.post(urlRequestApi, QS.stringify(dataRequest));

            if (typeof res_firstStep.data.hash !== 'undefined') {
                context.commit('set_hash', res_firstStep.data.hash)
            }

            const dataFirstStep = res_firstStep.data.result.entry_list[0].name_value_list

            const fields = {
                date_repair:            'set_siteCustomizationDataDataCacheUpdate',
                captcha_on:             'set_captchaSettingsRerecaptchaEnable',
                captcha_site_key:       'set_captchaSettingsRerecaptchaSiteKey',
                contact_phones:         'set_siteCustomizationContactUsPagePhone',
                contact_address:        'set_siteCustomizationContactUsPageAddress',
                contact_us_mail_to:     'set_siteCustomizationContactUsContactUsMailTo',
                hf_address:             'set_siteCustomizationDataHeaderFooterAddress',
                hf_phone:               'set_siteCustomizationDataHeaderFooterPhone',
                hf_logo:                'set_siteCustomizationDataHeaderFooterLogo',
                hf_copyright:           'set_siteCustomizationDataHeaderFooterCopyright',
                hf_show_footer:         'set_siteCustomizationDataHeaderFooterShowFooter',
                hf_show_copyright:      'set_siteCustomizationDataHeaderFooterShowCopyright',
                hf_show_menus:          'set_siteCustomizationDataHeaderFooterShowFooterMenus',
                hf_footer_font_color:   'set_siteCustomizationDataHeaderFooterFooterFontColor',
                hf_footer_back_color:   'set_siteCustomizationDataHeaderFooterFooterBackgroundColor',
                social_facebook:        'set_siteCustomizationDataSocialMenuUrlFacebookPage',
                social_twitter:         'set_siteCustomizationDataSocialMenuUrlTwitterPage',
                social_youtube:         'set_siteCustomizationDataSocialMenuUrlYouTubePage',
                social_pinterest:       'set_siteCustomizationDataSocialMenuUrlPinterestPage',
                social_tumblr:          'set_siteCustomizationDataSocialMenuUrlTumblrPage',
                social_instagram:       'set_siteCustomizationDataSocialMenuUrlUrlInstagramPage',
                social_linkedin:        'set_siteCustomizationDataSocialMenuUrlUrlLinkedinPage',
                social_vimeo:           'set_siteCustomizationDataSocialMenuUrlUrlVimeoPage',
                cf_font_basic:          'set_siteCustomizationDataColorAndFontsBasicFont',
                cf_font_basic_color:    'set_siteCustomizationDataColorAndFontsColorBasicFont',
                cf_button_icon_link_color: 'set_siteCustomizationDataColorAndFontsColorButton',
                cf_button_text_hover:   'set_siteCustomizationDataColorAndFontsColorButtonHover',
                cf_appt_color:          'set_siteCustomizationDataAppointmentsPageColorAppointmentButton',
                cf_appt_color_font:     'set_siteCustomizationDataAppointmentsPageColorFontAppointmentButton',
                cf_appt_color_disable:  'set_siteCustomizationDataAppointmentsPageColorManegeButton',
                cf_appt_color_disable_font: 'set_siteCustomizationDataAppointmentsPageColorFontManegeButton',
                cf_appt_color_empty:    'set_siteCustomizationDataAppointmentsPageColorEmptyButton',
                cf_appt_color_empty_font:'set_siteCustomizationDataAppointmentsPageColorFontEmptyButton',
                cf_distance_options:    'set_siteCustomizationDataAppointmentsPageDistanceOptions',
                profile_opt_in_out:     'set_siteCustomizationDataProfilePageMessageOptIn',

                slider_color_banner_text: 'set_siteCustomizationDataSliderColorBannerText',
                slider_color_button_hover:'set_siteCustomizationDataSliderColorButtonHover',
                slider_color_button_hover_text: 'set_siteCustomizationDataSliderColorButtonHoverText',
                show_border_slider_button: 'set_siteCustomizationDataSliderShowBorderSliderButton',

                msg_lack_donor:         'set_siteCustomizationDataMessagesNotFoundDonor',
                msg_inaccurate_info:    'set_siteCustomizationDataMessagesNotFoundDonorForTemporaryReg',
                msg_lack_places:        'set_siteCustomizationDataMessagesNotFoundDonationLocation',
                msg_lack_email:         'set_siteCustomizationDataMessagesNotFoundEmail',
                msg_login_phone:        'set_siteCustomizationDataMessagesSupportsPhone',
                msg_prev_donation:      'set_siteCustomizationDataMessagesPrevTab',
                msg_create_new_account: 'set_siteCustomizationDataMessagesCreateNewAccount',
                msg_email_validation:   'set_siteCustomizationDataMessagesEmailValidation',
                msg_unique_email_validation: 'set_siteCustomizationDataMessagesUniqueEmailValidation',
                msg_login_upper_text:   'set_siteCustomizationDataMessagesLoginUpperText',
                msg_login_bottom_text:  'set_siteCustomizationDataMessagesLoginBottomText',
                msg_don_loc_list_title: 'set_siteCustomizationDataMessagesDonLocListTitle',
                msg_unavailable:        'set_siteCustomizationDataMessagesUnavailable',

                msg_left_text_block_header: 'set_siteCustomizationHomePageLeftTextBlockHeader',
                msg_left_text_block_body: 'set_siteCustomizationHomePageLeftTextBlockBody',
                left_text_block_link: 'set_siteCustomizationHomePageLeftTextBlockLink',
                left_text_block_link_address: 'set_siteCustomizationHomePageLeftTextBlockLinkAddress',
                left_text_block_button: 'set_siteCustomizationHomePageLeftTextBlockButton',
                left_text_block_button_link: 'set_siteCustomizationHomePageLeftTextBlockButtonLink',
                msg_right_text_block_header: 'set_siteCustomizationHomePageRightTextBlockHeader',
                msg_right_text_block_body: 'set_siteCustomizationHomePageRightTextBlockBody',
                right_text_block_link: 'set_siteCustomizationHomePageRightTextBlockLink',
                right_text_block_link_address: 'set_siteCustomizationHomePageRightTextBlockLinkAddress',
                right_text_block_button: 'set_siteCustomizationHomePageRightTextBlockButton',
                right_text_block_button_link: 'set_siteCustomizationHomePageRightTextBlockButtonLink',

                sms_enable:             'set_crmSettingsSmsEnable',
                sms_number:             'set_crmSettingsSmsNumber',

                assigned_user_id:       'set_crmSettingsSendEmailIdUserPostman',
            }

            for (const [key, value] of Object.entries(fields)) {
                if (typeof dataFirstStep[key] !== 'undefined' && typeof dataFirstStep[key].value !== 'undefined' ) {
                    context.commit(value, xlooLib.decodeHtmlEntity(dataFirstStep[key].value));
                }
            }
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_getSiteSettings: async (context) => {

        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'getSiteSettings',
        }
        try {
            const response = await axios.post(urlRequest, QS.stringify(dataRequest));

            if (response.data.result.entry_list.length > 0) {
                const dataResponse = response.data.result.entry_list[0].name_value_list

                const dataResponseMutation = {
                    description: dataResponse.description.value,
                    donorCardTmplateId: dataResponse.pdf_template_id_c.value,

                    findDonor: dataResponse.find_donor.value,

                    dhqOn: dataResponse.dhq_on.value !== "0",
                    dhqlocation: dataResponse.dhq_location.value,
                    dhqLoginRestUrl: dataResponse.dhq_login_rest_url.value,

                    doubleCalc: dataResponse.double_calc.value,
                    ldTotalField: dataResponse.ld_total_field.value,

                    hideEmptyLocation: dataResponse.hide_empty_location.value,
                    hideZeroProcedures: dataResponse.hide_zero_procedures.value,

                    passAttemptsNum: dataResponse.pass_attempts_num.value,
                    passAttemptsOn: dataResponse.pass_attempts_on.value,

                    passDelayOn: dataResponse.pass_delay_on.value,
                    passDelayMin: dataResponse.pass_delay_min.value,
                    passDelayMax: dataResponse.pass_delay_max.value,

                    passSizeMin: dataResponse.pass_size_min.value,
                    passContainNumber: dataResponse.pass_contain_number.value,
                    passContainSpecial: dataResponse.pass_contain_special.value,
                    passContainUpper: dataResponse.pass_contain_upper.value,
                    passContainLower: dataResponse.pass_contain_lower.value,
                }

                context.commit('set_siteSettings', dataResponseMutation)
                const dataRequest = {
                    action: 'getUrlSrt',
                }
                try {
                    const response = await axios.post(urlRequest, QS.stringify(dataRequest));
                    context.commit('set_configurationSiteUrlSrtSite', response.data.srtUrl)
                } catch (e) {
                    context.commit('setError', e, {root: true});
                }
            }
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }

    },
    SET_bookingInfo: async (context) => {
        let urlDonorPortal = context.getters.configurationSite.urlSite
        if (typeof urlDonorPortal === 'undefined' || !urlDonorPortal) {
            if (location.hostname === 'localhost') {
                urlDonorPortal = "http://localhost:8080/donorportal/"
            } else {
                urlDonorPortal = location.origin + location.pathname
            }
        }
        const urlRequest = urlDonorPortal + 'api'

        const dataRequest = {
            action: 'entryPoints',
            entryAction: 'bookingInfo',
        }
        try {
            const result = await axios.post(urlRequest, QS.stringify(dataRequest))
            const resultData = result.data.result;
            if (typeof resultData.editable !== 'undefined') {
                context.commit('set_crmSettingsEditableArr', {key: 'dob', val: resultData.editable.dob})
                context.commit('set_crmSettingsEditableArr', {key: 'donorId', val: resultData.editable.donorid})
                context.commit('set_crmSettingsEditableArr', {key: 'firstName', val: resultData.editable.first_name})
                context.commit('set_crmSettingsEditableArr', {key: 'lastName', val: resultData.editable.last_name})
                context.commit('set_crmSettingsEditableArr', {key: 'phoneHome', val: resultData.editable.phone_home})
                context.commit('set_crmSettingsEditableArr', {
                    key: 'addressCity',
                    val: resultData.editable.primary_address_city
                })
                context.commit('set_crmSettingsEditableArr', {
                    key: 'addressCountry',
                    val: resultData.editable.primary_address_country
                })
                context.commit('set_crmSettingsEditableArr', {
                    key: 'addressPostalCode',
                    val: resultData.editable.primary_address_postalcode
                })
                context.commit('set_crmSettingsEditableArr', {
                    key: 'addressState',
                    val: resultData.editable.primary_address_state
                })
                context.commit('set_crmSettingsEditableArr', {
                    key: 'addressStreet',
                    val: resultData.editable.primary_address_street
                })
            }

            if (typeof resultData.eligibilities !== 'undefined') context.commit('set_crmSettingsEligibilities', resultData.eligibilities)
            if (typeof resultData.order !== 'undefined') context.commit('set_crmSettingsOrder', resultData.order)
            if (typeof resultData.softdonorCodes !== 'undefined') context.commit('set_crmSettingsSoftDonorCodes', resultData.softdonorCodes)
            if (typeof resultData.pfDD !== 'undefined') context.commit('set_crmSettingsPhoneFormats', resultData.pfDD)

            if (typeof resultData.pfSel !== 'undefined') context.commit('set_crmSettingsPhoneFormat', resultData.pfSel)
            if (typeof resultData.geoParams !== 'undefined') {
                const localRoutingParams = xlooLib.getData(resultData.geoParams);
                if (typeof localRoutingParams.OSRM_LANG !== 'undefined') context.commit('set_crmSettingsGeoSettingsArr', {
                    key: 'lang',
                    val: localRoutingParams.OSRM_LANG
                })
                if (typeof localRoutingParams.OSRM_UNIT !== 'undefined') {
                    switch (localRoutingParams.OSRM_UNIT) {
                        case 'MI':
                            context.commit('set_crmSettingsGeoSettingsArr', {key: 'unit', val: 'imperial'})
                            context.commit('set_crmSettingsGeoSettingsArr', {key: 'scale', val: 0.621371192})
                            context.commit('set_crmSettingsGeoSettingsArr', {key: 'displayRuler', val: 'mi'})
                            context.commit('set_crmSettingsGeoSettingsArr', {key: 'labelDisplayRuler', val: 'miles'})
                            break;
                        case 'KM':
                            context.commit('set_crmSettingsGeoSettingsArr', {key: 'unit', val: 'metric'})
                            context.commit('set_crmSettingsGeoSettingsArr', {key: 'scale', val: null})
                            context.commit('set_crmSettingsGeoSettingsArr', {key: 'displayRuler', val: 'km'})
                            context.commit('set_crmSettingsGeoSettingsArr', {
                                key: 'labelDisplayRuler',
                                val: 'kilometers'
                            })
                            break;
                    }
                }
                if (typeof resultData.emailAccounts !== 'undefined'){
                    for (let key in resultData.emailAccounts) {
                        context.commit('communication/set_communicationEmailSettings', {
                            emailUserId: resultData.emailAccounts[key][0]
                        }, {root: true})
                    }
                }
                if (typeof resultData.timezone !== 'undefined'){

 //                  We have fixed bug with show Appointments date at SRT and DonorPortal
                    context.commit('set_siteSettings', { timeZone: resultData.timezone })
//                    context.commit('set_siteSettings', { timeZone: 'UTC' })
                }
                if (typeof resultData.required !== 'undefined') {
                    context.commit('set_crmSettingsRequiredArr', {key: 'dob', val: resultData.required.dob})
                    context.commit('set_crmSettingsRequiredArr', {key: 'donorId', val: resultData.required.donorid})
                    context.commit('set_crmSettingsRequiredArr', {key: 'firstName', val: resultData.required.first_name})
                    context.commit('set_crmSettingsRequiredArr', {key: 'lastName', val: resultData.required.last_name})
                    context.commit('set_crmSettingsRequiredArr', {key: 'phoneMobile', val: resultData.required.phone_mobile})
                    context.commit('set_crmSettingsRequiredArr', {key: 'email', val: resultData.required.email})
                }
            }

        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_getPreviousDonationLayout: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'getPreviousDonationLayout',
            types: ["default"],
            views: ["list"],
        }
        try {
            const res_getModuleLayout = await axios.post(urlRequest, QS.stringify(dataRequest))
            context.commit('set_previousDonation', {arrCreateTab: res_getModuleLayout.data.Donor_Donations})
            return res_getModuleLayout.data
        } catch (e) {
            context.commit('setError', e, {root: true})
            throw e
        }
    },
    SET_getPreviousDonation: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const getStatusList = await context.dispatch('SET_getDonationStatusList');
        const dataRequest = {
            action: 'getPreviousDonations',
            idDonor: context.rootGetters['donorInformation/idDonor'],
            statusList: getStatusList.data.result.list,
        }
        try {
            return await axios.post(urlRequest, QS.stringify(dataRequest))
        } catch (e) {
            context.commit('setError', e, {root: true})
            throw e
        }
    },
    SET_getDonationStatusList: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'

        const dataRequest = {
            action: 'apiPointPortal',
            apiPointAction: 'DonationStatusList',
        }
        try {
            return await axios.post(urlRequest, QS.stringify(dataRequest))
        } catch (e) {
            context.commit('setError', e, {root: true})
            throw e
        }
    },
    SET_getTotalLifeTimeDonations: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'apiPointPortal',
            apiPointAction: 'SumOfPreviousDonations',
            idDonor: context.rootGetters['donorInformation/idDonor'],
        }
        try {
            return await axios.post(urlRequest, QS.stringify(dataRequest))
        } catch (e) {
            context.commit('setError', e, {root: true})
            throw e
        }
    },
    // eslint-disable-next-line no-unused-vars
    SET_dataCacheUpdate: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
//        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api?action=getModuleLayout'-
        const dataRequest = {
            action: 'getDataCacheUpdate',
        }
        try {
            // eslint-disable-next-line no-unused-vars
            const res_dataCacheUpdate = await axios.post(urlRequest, QS.stringify(dataRequest))
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },

}


